/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./game-difficulty-slider.vue?vue&type=template&id=16535aaa&scoped=true&"
import script from "./game-difficulty-slider.vue?vue&type=script&lang=js&"
export * from "./game-difficulty-slider.vue?vue&type=script&lang=js&"
import style0 from "./game-difficulty-slider.vue?vue&type=style&index=0&id=16535aaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16535aaa",
  null
  
)

export default component.exports